export default "__VITE_PUBLIC_ASSET__d8c8aeb8__"